import cs from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import { type FC, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Box } from '@/DesignSystem/Component';
import { authSetIsTransitioningAction } from '@/Module/Auth/Store/Slice/AuthSlice';
import { FILE_BROWSER_URL } from '@/Module/Core/Constant';
import type { IBaseComponentProps } from '@/Module/Core/Model/DataModel';
import { selectedGradeSelector } from '@/Module/Grade/Store/Selector/findGradeSelector';
import { prepareLessonUrl } from '@/Module/Lesson/Helper';
import type { ILesson } from '@/Module/Lesson/Model/DataModel';
import { lessonSelectById } from '@/Module/Lesson/Store/Selector';
import { useAppSelector } from '@/Module/Store/Hook';
interface ILessonProps extends IBaseComponentProps {
  id: ILesson['id'];
  imgWidth?: number;
  hideTitle?: boolean;
}
const Lesson: FC<ILessonProps> = ({
  id,
  className,
  imgWidth,
  hideTitle
}) => {
  const dispatch = useDispatch();
  const entity = useAppSelector(state => lessonSelectById(state, id));
  const grade = useAppSelector(selectedGradeSelector);
  const gradeSeoUrl = useAppSelector(state => state.grade.selectedGradeSeoUrl);
  const width = imgWidth ?? 267;
  const height = width / (3 / 4);
  const handleClick = async () => {
    dispatch(authSetIsTransitioningAction(true));
  };
  const imageUrl = useMemo(() => {
    if (!entity?.id) return `${FILE_BROWSER_URL}/img/img-lesson-default.webp`;
    return `${FILE_BROWSER_URL}/course/${entity?.id}.webp` || entity.coverImageUrl;
  }, [entity?.id]);
  if (!entity) return null;
  return <Box className={cs('relative p-1', className)} color="primaryLight" hover data-sentry-element="Box" data-sentry-component="Lesson" data-sentry-source-file="Lesson.tsx">
      <Link onClick={handleClick} href={prepareLessonUrl({
      ...entity,
      gradeSeoUrlSlug: grade?.seoUrlSlug ?? gradeSeoUrl
    })} data-sentry-element="Link" data-sentry-source-file="Lesson.tsx">
        <Image width={width} height={height} className="relative z-0 w-full" src={imageUrl} alt={entity.title} data-sentry-element="Image" data-sentry-source-file="Lesson.tsx" />

        {!hideTitle && <span className="absolute bottom-1 left-1 z-20 inline-flex h-12 items-center bg-blueTwo px-4 font-bold text-blueFive">
            <h3>{entity.title}</h3>
          </span>}
      </Link>
    </Box>;
};
export default Lesson;